import React from 'react'
import { AvatarProfile } from '../_components'
import { SidebarData as menu } from './SidebarMenu'
import "./Navbar.css"
import UGLogo from '../_images/uganda.png'

export default function Navbar() {

  return (
    <>
        <nav className="sticky h-20 top-0 z-50 flex bg-gray-300 items-center justify-between px-5">
            <div className="h-full flex items-center justify-center py-2">
                <div className="h-full">
                    <img src={UGLogo} alt="Uganda Logo" className="h-full" />
                </div>
                <div className="h-full flex flex-col items-center justify-center p-2">
                    <h2 className="uppercase font-bold md:text-sm lg:text-sm text-xs">
                        {`Small Medium Scale`}
                    </h2>
                    <h2 className="font-bold md:text-sm lg:text-sm text-xs">
                        {`Irrigation Scheme`}
                    </h2>
                </div>
            </div>
            <div className="flex flex-col items-center justify-start">
                <div className="flex items-center justify-center">
                    <div className="rounded-full">
                        <AvatarProfile label={localStorage.getItem( "username" )} />
                    </div>
                    <button type="button" onClick={ async () => {
                        await localStorage.clear()
                        await localStorage.setItem( "name", "login" )
                        return window.location.reload()
                    } } className="text-xs text-red-500">
                        {`Logout`}
                    </button>
                </div>
                <div className="text-xs md:text-sm lg:text-sm font-bold">
                    {`Scheme: ${localStorage.getItem( "scheme" )?.toUpperCase()}`}
                </div>
            </div>
        </nav>
        <aside className="h-full md:block lg:block md:w-[250px] lg:w-[250px] bg-[#2596BE] fixed flex flex-col items-center justify-start py-5">
            {menu.map( ( item, index ) => {
                return <SidebarLink key={index} item={item} active={localStorage.getItem( "link" ) === item.slug} />
            } )}
        </aside>
    </>
  )
}

const SidebarLink = ( { item } ) => {
    const [ subnav, setSubNav ] = React.useState( false )

    const showSubNav = () => setSubNav( !subnav )

    const handlePress  = async slug => {
        if( typeof slug === "object" ) {
            await localStorage.setItem( "parent", slug[ 0 ] )
            await localStorage.setItem( "name", slug[ 1 ] )

            if( slug[ 2 ] ) {
                await localStorage.setItem( "leaderType", slug[ 2 ] )
            }
        }
        else {
            await localStorage.setItem( "name", slug )
        }
        //remove tag it exists
        if( localStorage.getItem( "tag") ) {
            await localStorage.removeItem( "tag" )
        }
        
        return window.location.reload()
    }

    return (
        <>
        <div onClick={item.subNav ? showSubNav : () => handlePress( item.slug )} className={`${localStorage.getItem( "parent" ) === item.slug ? "bg-[#252831] border-l-2 text-white flex justify-between items-center p-2 h-12 text-xs hover:bg-[#252831] hover:border-l-2 hover:text-white hover:cursor-pointer" : "text-white flex justify-between items-center p-2 h-10 text-xs hover:bg-[#252831] hover:border-l-2 hover:text-white hover:cursor-pointer" }`}>
            <div className="flex items-center justify-center">
                {item.icon}
                <div className="ml-4">
                    {item.title}
                </div>
            </div>
            <div>
                {item.subNav &&  subnav ? item.iconOpened : item.subNav ? item.iconClosed : null }
            </div>
        </div>
        {subnav && item.subNav.map( ( val, index ) => {
            return (
                <div onClick={() =>handlePress( val.slug )} key={index} className={`${localStorage.getItem( "link" ) === val.slug[ 1 ] && "bg-gray-50 text-black font-bold"} bg-white h-10 border-b border-gray-300 flex items-center justify-start no-underline text-gray-500 text-xs hover:bg-[#DDD] hover:cursor-pointer`}>
                    <div className="text-start md:px-14 lg:px-14">{val.title}</div>
                </div>
            )
        }  )}
        </>
    )
}
